export const dataCollection = [
  {
    title: 'Account information',
    description: `If you create an account, we may collect certain personal
    information that can be used to identify you, such as your
    full name, email address, password, postal address, public
    blockchain wallet address, and phone number.`,
  },
  {
    title: 'Company profile',
    description: `You also have the option to share information about your company, including the company name, address, and phone number, and the names, titles, phone numbers, and email addresses of your business, financial, and operational contacts. Please ensure you have the necessary consents from any individual whose personal information you upload to our website(s).`,
  },
  {
    title: 'Financial Information',
    description: `In connection with a financial transaction via the Services, or if you enroll in our banking services, our third-party payment service providers may collect your credit or debit card information, digital wallet address, or other financial and payment information. We may directly collect or store payment card or financial information entered through our Services including the last four digits of your payment card or financial information and may receive other information associated with your payment card information (e.g., your billing details). For banking services, including any banking as a service, cash back, or rewards program, we or our third-party service providers may collect your transaction, digital wallet address, and purchase history details.`,
  },
  {
    title: 'Information you import, share, or upload',
    description: `As part of the Services, you may also elect to import, share, or upload documents, information, or records including but not limited to financial information, about the properties you buy, sell, own, or lease. This information may include, at your discretion, account balance information, payee details, payment amounts; educational materials or references; personal or professional contact information; property addresses, details, descriptions, listings, photos or videos; rent applications, background or credit checks, leases, and payment records or receipts; maintenance requests, invoices, and payment records; income and expenses; service provider or vendor contact information and contracts; tax-related information, including 1099s, assessments, property tax appeals; or records relating to landlord-tenant disputes or litigation.`,
  },
  {
    title: 'Property management information',
    description: `When you use the Services to manage real property, either directly or through a professional property manager or LLC administrator, we may collect information related to the property being managed, including the property address, property characteristics, and personal information of those involved in the transaction.`,
  },
  {
    title: 'Registration for sweepstakes or contests',
    description: `We may run sweepstakes and contests. Contact information you provide may be used to reach you about the sweepstakes or contest and for other promotional, marketing, and business purposes, if permitted by law. In some jurisdictions, we are required to publicly share information of winners.`,
  },
  {
    title: 'Your communications with us',
    description: `We collect personal information from you such as your full name, email address, phone number, social media identifier, or mailing address when you request information about our Services or request customer or technical support.
    `,
  },
  {
    title: '',
    description: `We may also contact you to participate in surveys. If you decide to participate, you may be asked to provide certain information, which may include personal information.
    `,
  },
]

export const autoDataCollection = [
  {
    title: 'Automatic data collection',
    description:
      'We, as well as third parties that provide content, advertising, or other functionality on the Services, may collect certain information automatically when you use the Services. This information may include your Internet protocol (IP) address, user settings, media access control address (MAC address), cookie identifiers, mobile carrier, mobile advertising identifier, digital wallet address, and other unique identifiers, details about your browser, operating system or device, location information, Internet service provider, pages that you visit before, during, and after using the Services, information about the links you click, digital wallet address, and other information about how you use the Services. Information we collect may be associated with accounts and other devices.',
  },
  {
    title:
      'Cookies, pixel tags/web beacons, analytics information, and interest-based advertising technologies',
    description: `We, as well as third parties that provide content, advertising, or other functionality on the Services, may use cookies, pixel tags, local storage, and other technologies ("Technologies") to automatically collect information from your devices through the Services. Technologies are essentially small data files placed on your computer, tablet, mobile phone, or other devices that allow us and our partners to record certain pieces of information whenever you visit or interact with our Services. Our uses of these Technologies fall into the following general categories:`,

    info: [
      {
        title: 'Operationally necessary',
        description: `This includes Technologies that allow you access to our Services, applications, and tools that are required to identify irregular site behavior, prevent fraudulent activity, and improve security or that allow you to make use of our functionality.`,
      },
      {
        title: 'Performance related',
        description: `We may use Technologies to assess the performance of our Services, including as part of our analytic practices to help us understand how our visitors use the Services.`,
      },
      {
        title: 'Functionality related',
        description: `We may use Technologies that allow us to offer you enhanced functionality when accessing or using our Services. This may include identifying you when you sign into our Services or keeping track of your specified preferences, interests, or past items viewed.
        `,
      },
      {
        title: 'Advertising or targeting related',
        description: `We may use first party or third-party Technologies to deliver content, including ads relevant to your interests, on our Services or on third-party sites.
        `,
      },
    ],
  },
]

export const servicesData = [
  'Managing your information and accounts',
  'Providing access to certain areas, functionalities, and features of our Services',
  'Answering requests for customer or technical support',
  'Communicating with you about your account, activities on our Services, and policy changes',
  'Processing your financial information and other payment methods for products or Services purchased',
  'Processing applications for goods or services and completing requested transactions',
  'Allowing you to register for events',
  'Furnishing you with customized materials about offers, products, and services that may be of interest, including new content or services from VTR Connect or nonaffiliated third parties',
  'Providing you the means to perform activities or transact with third party goods or services providers.',
]
export const adminPurposeData = [
  'Pursuing our legitimate interests such as direct marketing, research and development (including marketing research), network and information security, and fraud prevention',
  'Detecting security incidents, protecting against malicious, deceptive, fraudulent, or illegal activity, and prosecuting those responsible for that activity',
  'Measuring interest and engagement in our Services',
  'Short-term, transient use, such as contextual customization of ads',
  'Researching and developing products, services, marketing, or security procedures to improve their performance, resilience, reliability, or efficiency',
  'Improving, upgrading, or enhancing our Services',
  'Developing new products and Services',
  'Ensuring internal quality control and safety',
]

export const otherPurposeData = [
  {
    title: 'Consent',
    description:
      'We may use personal information for other purposes that are clearly disclosed to you at the time you provide personal information or with your consent.',
  },
  {
    title: 'Use de-identified and aggregated information',
    description:
      'We may use personal information and other data about you to create de-identified and aggregated information, such as de-identified demographic information, de-identified location information, information about the computer or device from which you access our Services, or other analyses we create. For example, we may also analyze general characteristics such as record types and volumes, in order to price, audit, and improve the Services.',
  },
]
export const discloseData = [
  {
    title: 'Contractors',
    description:
      'We may disclose information to contractors, service providers, and other third parties we use to support our business and who are bound by contractual obligations to keep personal information confidential. This includes service providers that provide us with IT support, hosting, payment processing, customer service, and related services.',
  },
  {
    title: 'Business Partners',
    description:
      'We may share your personal information with business partners to provide you with a product or service that may be of interest to you. We may also share your personal information to business partners with whom we jointly offer products or services.',
  },
  {
    title: 'Law Enforcement/Governmental Agencies',
    description: `We may share your personal information if required or appropriate to comply with law enforcement, national security requests, or legal process, such as a court order or subpoena; protect your, our, or others' rights, property, or safety; enforce our policies or contracts; collect amounts owed to us; or assist with an investigation or prosecution of suspected or actual illegal activity.`,
  },
  {
    title: 'Acquiring Parties',
    description:
      'If we sell all or substantially all of our assets, or are otherwise acquired, your personal information may be transferred to a third party. We may also transfer or assign personal information to a third party in the event of some other change of control (such as the result of a bankruptcy proceeding).',
  },
]

export const privacyChoices = [
  {
    title: 'Cookies and interest-based advertising',
    description:
      'You may stop or restrict the placement of Technologies on your device or remove them by adjusting your preferences as your browser or device permits. If you adjust your preferences, our Services may not work properly. Please note that cookie-based opt-outs are not effective on mobile applications. However, you may opt-out of personalized advertisements on some mobile applications by following the instructions for those mobile device providers.',
  },
  {
    title: 'General',
    description:
      'You have certain choices about your personal information. Where you have consented to the processing of your personal information, you may withdraw that consent at any time and prevent further processing by contacting us as described below. Even if you opt out, we may still collect and use non-personal information regarding your activities on our Services and for other legal purposes as described above.',
  },
]
export const rightsData = [
  {
    title: 'Access to/port information ',
    description:
      'about you, including: (i) confirming whether we are processing your personal information; (ii) obtaining access to or a copy of your personal information in a structured, commonly used, and machine readable format; and (iii) receiving an electronic copy of personal information that you have provided to us, or asking us to send that information to another company in a structured, commonly used, and machine readable format (the “right of data portability”).',
  },
  {
    title: 'Request correction ',
    description:
      'of your personal information where it is inaccurate or incomplete. In some cases, we may provide self-service tools that enable you to update your personal information, or we may refer you to the controller of your personal information who is able to make the correction.',
  },
  {
    title: 'Request deletion ',
    description:
      'of your personal information where it is inaccurate or incomplete. In some cases, we may provide self-service tools that enable you to update your personal information, or we may refer you to the controller of your personal information who is able to make the correction.',
  },
  {
    title: 'Withdraw your consent ',
    description:
      'of your personal information, subject to certain exceptions prescribed by law.',
  },
  {
    title: 'Request restriction of or object to ',
    description: 'processing of your personal information.',
  },
  {
    title: 'Withdraw your consent ',
    description: 'to our processing of your personal information.',
  },
]
